// extracted by mini-css-extract-plugin
export default {"box":"filters_box__Q3Kqw","label":"filters_label__qOjK5"};